<template>
    <a :class="classes" class="text-danger" href="#" @click.prevent="process()">
        <slot name="icon">
            <i class="pi pi-times p-button-danger"></i>
        </slot>
        <slot></slot>
    </a>
</template>

<script>
    import swal from 'sweetalert2';
    import axios from "axios";

    export default {
        components: {
            swal,
        },
    
        props: {
            classes: {
                type: String,
            },
            routePath: {
                type: String,
                required: true,
            },

            redirectPath: {
                type: String,
                default: null,
            },

            removeElement: {
                type: String,
                default: null,
            },

            callback: {
                type: Function,
                default: () => {},
            },
        },

        methods: {
            process () {
                new swal({
                    title: 'Ви впевнені?',
                    text: 'Елемент буде видалено',
                    icon: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
                    buttons: ['Скасувати', 'Підтвердити'],
                }).then((result) => {
                    if (!result.isConfirmed) {
                        return
                    }

                    axios.delete(this.routePath)
                        .then(({data: {message}}) => {
                            this.callback(message)

                            this.$emit('item-deleted')

                            if (this.redirectPath) {
                                location.href = this.redirectPath
                            }

                            if (this.removeElement) {
                                document.getElementById(this.removeElement).remove()
                            }
                        })
                        .catch((response) => {
                            console.log(response);
                        });
                });
            },
        },
    }
</script>
